function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.72 15.5-6.93-12a1 1 0 0 0-.86-.5H9.07a1 1 0 0 0-.86.5l-6.93 12a1 1 0 0 0 0 1l6.93 12a1 1 0 0 0 .86.5h13.86a1 1 0 0 0 .86-.5l6.93-12a1 1 0 0 0 0-1ZM22.35 27H13v-8.44a3.41 3.41 0 0 1 3.37-.22 5.25 5.25 0 0 0 5.14-.48A1 1 0 0 0 22 17v-6a1 1 0 0 0-.45-.84 1 1 0 0 0-.95-.08c-2 .88-2.79.61-3.69.3-1.41-.48-2.71-.73-5.39.74A1 1 0 0 0 11 12v15H9.65L3.3 16 9.65 5h12.7l6.35 11ZM13 16.36v-3.75c1.73-.86 2.38-.63 3.26-.33a5.57 5.57 0 0 0 3.74.14v4a3.23 3.23 0 0 1-3 0 6.63 6.63 0 0 0-2.16-.42 4.94 4.94 0 0 0-1.84.36Z",
    style: {
      fill: "#fff"
    }
  })));
};
export default SvgFlag;